<template lang="pug">
.meal-sleep-subsidy-page(v-if="!loadFailed" :style="pageStyle")
  //- 返回按钮
  img.back-btn(
    src="https://m.hellobike.com/7f1888d8_back-white.png"
    @click="goBack"
  )

  //- 副标题
  .subsidy-subtitle(v-if="taskGroup.subsidySubName") {{ taskGroup.subsidySubName }}

  //- ========== 我的组件 ==========
  //- 进度概览：今日进度 + 三个阶梯子任务 + 领取提醒开关
  ProgressOverview(:task-group="taskGroup")

  //- 按钮引导：领取按钮 + 领奖弹窗 + 看视频链路
  ActionButton(
    :task-group="taskGroup"
    @task-refresh="handleTaskRefresh"
  )

.error-page(v-else)
  Empty
</template>

<script>
import { getSubsidyDetail } from '@/api/bounty';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getSource, getTokenAndKey } from '@/utils';
import { env, Native } from '@hb/NBridge/lib/h5';
import Empty from '@/components/empty';
import ProgressOverview from './components/progress-overview';
import ActionButton from './components/action-button';
import { getTasksByTime } from './common/utils';

const IMG = {
  // 早-时间外
  BG_MORNING_OUTSIDE: 'https://m.hellobike.com/87c4e503_morgin-out-time.png',
  // 早-时间内可领
  BG_MORNING_ACTIVE: 'https://m.hellobike.com/c9186f43_mm-timing.png',
  // 早-时间内不可领
  BG_MORNING_DONE: 'https://m.hellobike.com/f1ba1e49_mm-no.png',
  // 中-时间外
  BG_NOON_OUTSIDE: 'https://m.hellobike.com/73bae620_noon-out-timing.png',
  // 中-时间内可领
  BG_NOON_ACTIVE: 'https://m.hellobike.com/8823ad22_no-timing.png',
  // 中-时间内不可领
  BG_NOON_DONE: 'https://m.hellobike.com/0ae86373_no-no.png',
  // 晚-时间外
  BG_NIGHT_OUTSIDE: 'https://m.hellobike.com/8fc82493_night-out-timing.png',
  // 晚-时间内可领
  BG_NIGHT_ACTIVE: 'https://m.hellobike.com/26dbcfb3_ni-timing.png',
  // 晚-时间内不可领
  BG_NIGHT_DONE: 'https://m.hellobike.com/c819eb9c_ni-no.png',
};

export default {
  name: 'MealSleepSubsidyDetail',
  components: {
    ProgressOverview, ActionButton, Empty,
  },
  data() {
    return {
      taskGroup: {},
      loadFailed: false,
    };
  },
  computed: {
    pageStyle() {
      return {
        backgroundImage: `url(${this.bgUrl})`,
        backgroundColor: this.pageBgColor,
      };
    },
    bgUrl() {
      const { period, status } = this.currentPeriodInfo;
      const key = `BG_${period}_${status}`;
      return IMG[key] || IMG.BG_MORNING_ACTIVE;
    },
    pageBgColor() {
      return this.currentPeriodInfo.period === 'NIGHT' ? '#063D2E' : '#84C900';
    },
    currentPeriodInfo() {
      const list = (this.taskGroup && this.taskGroup.subsidyDetailInfos) || [];
      const type = this.taskGroup && this.taskGroup.type;
      if (!list.length || !type) return { period: 'MORNING', status: 'OUTSIDE' };

      const now = this.getNowTimeStr();

      // 特殊逻辑：当前时间晚于晚间 endTime 且早于 23:59:59，直接展示晚-时间外
      const nightItem = list.find((i) => i.taskType === 3);
      if (nightItem && now > nightItem.endTime) {
        return { period: 'NIGHT', status: 'OUTSIDE' };
      }

      const periodMap = { 1: 'MORNING', 2: 'NOON', 3: 'NIGHT' };
      const period = periodMap[type] || 'MORNING';
      const item = list.find((i) => i.taskType === type) || list[0];

      let status = 'ACTIVE';
      if (now < item.startTime) {
        status = 'OUTSIDE';
      } else if (item.taskStatus === 'FINISHED') {
        status = 'DONE';
      }

      return { period, status };
    },
  },
  async created() {
    await this.loadTaskGroup();
    this.setupMidnightRefresh();
    this.reportPageView();
  },
  beforeDestroy() {
    this.reportPageViewOut();
    if (this.midnightTimer) {
      clearTimeout(this.midnightTimer);
      this.midnightTimer = null;
    }
  },
  methods: {
    goBack() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    getNowTimeStr() {
      const now = new Date();
      return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
    },
    async loadTaskGroup() {
      try {
        const { token } = await getTokenAndKey();
        const res = await getSubsidyDetail({ token });
        if (res && res.data) {
          this.taskGroup = res.data;
          this.loadFailed = false;
          return;
        }
        this.loadFailed = true;
      } catch (e) {
        this.loadFailed = true;
      }
    },

    getPageViewBusinessInfo() {
      const list = this.taskGroup?.subsidyDetailInfos || [];
      const { current, next } = getTasksByTime(list);
      const targetTask = current || next || {};
      return {
        task_status: targetTask?.taskStatus || '',
        taskBonus: targetTask?.taskBountyCount || '',
        taskname: targetTask?.taskName || '',
        taskid: targetTask?.taskCode || '',
        subtitle: this.taskGroup?.subsidySubName || '',
        main_title: this.taskGroup?.subsidyMainName || '',
        adsource: getSource(),
      };
    },

    reportPageView() {
      UBT.pageView({
        pageId: 'platform_sleepinglandingadver',
        categoryId: 'platform',
        businessInfo: this.getPageViewBusinessInfo(),
      });
    },

    reportPageViewOut() {
      UBT.pageViewOut({
        pageId: 'platform_sleepinglandingadver',
        categoryId: 'platform',
        businessInfo: this.getPageViewBusinessInfo(),
      });
    },

    handleTaskRefresh() {
      this.loadTaskGroup();
      this.$forceUpdate();
    },

    /**
     * 设置零点自动刷新：计算距离下一个 00:00 的毫秒数，到时重新拉取数据
     */
    setupMidnightRefresh() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setDate(midnight.getDate() + 1);
      midnight.setHours(0, 0, 0, 0);
      const ms = midnight - now;
      this.midnightTimer = setTimeout(() => {
        this.loadTaskGroup();
        this.setupMidnightRefresh();
      }, ms);
    },
  },
};
</script>

<style lang="less" scoped>
.meal-sleep-subsidy-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
}

.back-btn {
  position: absolute;
  top: 60px;
  left: 12px;
  width: 30px;
  height: 30px;
  z-index: 10;
}

.subsidy-subtitle {
  text-align: center;
  padding-top: 1.38rem;
  color: #fff;
  font-size: 0.16rem;
  font-weight: 700;
}

.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
}

</style>
